import classNames from "classnames";
import React, { useEffect, useState } from "react";
export default function BooleanButton(props) {
    var _a;
    const [isClicked, setClicked] = useState((_a = props.defaultState) !== null && _a !== void 0 ? _a : false);
    useEffect(() => {
        if (props.updateOnDefaultStateChange)
            setClicked(props.defaultState);
    }, [props.defaultState]);
    if (props.needsLabel == false) {
        return (React.createElement("button", { onClick: () => {
                props.onClick(!isClicked);
                setClicked(!isClicked);
            }, className: classNames(isClicked ?
                "boolean-button boolean-button-checked"
                : "boolean-button") },
            React.createElement("div", { className: isClicked ?
                    "boolean-button-thumb boolean-button-thumb-checked"
                    : "boolean-button-thumb" }, isClicked ? "✔" : "✖")));
    }
    return (React.createElement("label", { className: "input-label button-label" },
        props.label,
        React.createElement("button", { onClick: () => {
                props.onClick(!isClicked);
                setClicked(!isClicked);
            }, className: isClicked ? "boolean-button boolean-button-checked" : "boolean-button" },
            React.createElement("div", { className: isClicked ?
                    "boolean-button-thumb boolean-button-thumb-checked"
                    : "boolean-button-thumb" }, isClicked ? "✔" : "✖"))));
}
